if (!customElements.get('shop-the-looks')) {
  class ShopTheLooks extends HTMLElement {
    connectedCallback() {
      this.cartDrawer = document.querySelector('cart-drawer');
      this.looks = this.querySelectorAll('.js-stl-look');
      this.looks.forEach(look => this.setupLook(look));
    }

    setupLook(look) {
      const cards = Array.from(look.querySelectorAll('.js-stl-product'));
      const totalEl = look.querySelector('.js-stl-total');
      const addLookBtn = look.querySelector('.js-stl-add-look');
      const statusEl = look.querySelector('.js-stl-status');

      if (!cards.length || !totalEl) return;

      cards.forEach(card => {
        const optionInputs = card.querySelectorAll('.js-stl-option');
        if (!optionInputs.length) return;

        optionInputs.forEach(select => {
          select.addEventListener('change', () => {
            this.updateCardVariant(card);
            this.updateLookTotal(cards, totalEl);
          });
        });
      });

      this.updateLookTotal(cards, totalEl);

      if (addLookBtn) {
        addLookBtn.addEventListener('click', async () => {
          await this.addWholeLook(cards, statusEl, addLookBtn);
        });
      }
    }

    updateCardVariant(card) {
      const variantsScript = card.querySelector('.js-stl-variants');
      if (!variantsScript) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        return;
      }

      if (!variants.length) return;

      const selectedValues = Array.from(
        card.querySelectorAll('.js-stl-option')
      ).map(select => select.value);

      const matchedVariant = variants.find(variant => {
        if (!variant.available) return false;
        if (!Array.isArray(variant.options)) return false;

        return selectedValues.every((value, index) => {
          return variant.options[index] === value;
        });
      });

      const priceEl = card.querySelector('.js-stl-price');

      if (!matchedVariant) {
        card.dataset.selectedVariantId = '';
        card.dataset.selectedVariantPrice = '0';
        if (priceEl) priceEl.textContent = 'Niet beschikbaar';
        return;
      }

      card.dataset.selectedVariantId = String(matchedVariant.id);
      card.dataset.selectedVariantPrice = String(matchedVariant.price);
      if (priceEl) priceEl.textContent = this.formatMoney(matchedVariant.price);
    }

    updateLookTotal(cards, totalEl) {
      const total = cards.reduce((sum, card) => {
        const price = Number(card.dataset.selectedVariantPrice || 0);
        return Number.isFinite(price) ? sum + price : sum;
      }, 0);

      totalEl.dataset.totalCents = String(total);
      totalEl.textContent = this.formatMoney(total);
    }

    async addWholeLook(cards, statusEl, buttonEl) {
      const items = cards
        .map(card => Number(card.dataset.selectedVariantId))
        .filter(variantId => Number.isFinite(variantId) && variantId > 0)
        .map(variantId => ({ id: variantId, quantity: 1 }));

      if (!items.length) {
        this.showStatus(statusEl, 'Geen beschikbare varianten geselecteerd.');
        return;
      }

      buttonEl.classList.add('disabled');
      buttonEl.setAttribute('disabled', 'disabled');

      try {
        const payload = { items };

        if (this.cartDrawer) {
          payload.sections = this.cartDrawer
            .getSectionsToRender()
            .map(section => section.section);
          payload.sections_url = window.location.pathname;
        }

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(payload);

        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || 'Toevoegen mislukt.');
        }

        if (this.cartDrawer && data.sections) {
          this.cartDrawer.renderContents(data, true);
        }

        this.showStatus(statusEl, 'De hele look is toegevoegd.', false);
      } catch (error) {
        this.showStatus(statusEl, error.message || 'Er ging iets mis.');
      } finally {
        buttonEl.classList.remove('disabled');
        buttonEl.removeAttribute('disabled');
      }
    }

    formatMoney(cents) {
      const amount = Number(cents) / 100;
      if (
        typeof formatPrice === 'function' &&
        window.theme &&
        window.theme.settings &&
        window.theme.settings.money_with_currency_format
      ) {
        return formatPrice(window.theme.settings.money_with_currency_format, amount);
      }
      return `${amount.toFixed(2)}`;
    }

    showStatus(el, message, isError = true) {
      if (!el) return;
      el.classList.remove('hidden');
      el.textContent = message;
      el.style.color = isError
        ? 'rgb(var(--color-alert))'
        : 'rgb(var(--color-foreground))';
    }
  }

  customElements.define('shop-the-looks', ShopTheLooks);
}
